//Though this file is called 'input', this is more of it's own form because of the mobile.
import React, { Component } from 'react'
import { Button, Columns, Modal, Field } from 'components/elements'
import Loader from 'components/elements/coverLoader'
import MotoLookUp from 'components/elements/motorcycleLookUp/motoLookUp.js'
import './ridingExperienceInput.css'
import * as Yup from 'yup'
import { Formik } from 'formik'
import { apiProcess } from 'components/api/api.js'

const ridingExperienceSchema = Yup.object().shape({
  make: Yup.string()
    .nullable()
    .required('Make is required.'),
  model: Yup.string()
    .nullable()
    .required('Model is required.'),
  year: Yup.string()
    .nullable()
    .required('Year is required.'),
  years_experience: Yup.number()
    .nullable()
    .required('Years Experience is required.'),
})

const YEARS_EXPERIENCE_OPTIONS = [
  { key: '0', value: 0, text: '< 1 year' },
  { key: '1', value: 1, text: '1' },
  { key: '2', value: 2, text: '2' },
  { key: '3', value: 3, text: '3' },
  { key: '4', value: 4, text: '4' },
  { key: '5', value: 5, text: '5' },
  { key: '6', value: 6, text: '6' },
  { key: '7', value: 7, text: '7' },
  { key: '8', value: 8, text: '8' },
  { key: '9', value: 9, text: '9' },
  { key: '10', value: 10, text: '10 Plus' },
]

class RidingExperienceInput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ridingExpLoading: false,
      expError: this.props.expError,
      showSaveError: false,
      showSaveMessage: false,
      ridingExp:
        this.props.ridingExperience.length > 0
          ? this.props.ridingExperience
          : [],
      targetExpID: null,
      showExpInputModal: false,
      modalTitle: 'What bikes have you ridden?',
    }
  }

  openEditModal = (id) => {
    document.body.classList.add('hide-intercom')

    let modalTitle = 'What bikes have you ridden?'

    if (id !== 'new') {
      modalTitle = 'Edit Experience'
    }

    this.setState({
      targetExpID: id,
      showExpInputModal: true,
      modalTitle: modalTitle,
    })
  }

  updateYearsExperience = (yearsExperience, setFieldValue) => {
    setFieldValue('years_experience', yearsExperience)
  }

  updateCurrentlyOwn = (state, setFieldValue) => {
    setFieldValue('currently_own', state)
  }

  updateMake = (make, setFieldValue) => {
    setFieldValue('make', make)
    setFieldValue('category', '')
    setFieldValue('model', '')
    //setFieldValue('stock_id', '')
  }

  updateYear = (year, setFieldValue) => {
    setFieldValue('year', year)
    setFieldValue('make', '')
    setFieldValue('model', '')
    setFieldValue('category', '')
    //setFieldValue('stock_id', '')
  }

  updateModel = (modelInfo, setFieldValue) => {
    if (modelInfo.selectedModel !== null) {
      const { selectedModel, modelSpecifications } = modelInfo

      setFieldValue('model', selectedModel)

      if (modelSpecifications !== null) {
        setFieldValue('category', modelSpecifications.twisted_road_category)
        //setFieldValue('stock_id', modelSpecifications.id)
      } else {
        setFieldValue('category', '')
      }
    }
  }

  submitExperience = (values, setFieldError, setSubmitting) => {
    ridingExperienceSchema
      .validate(values, { abortEarly: false })
      .then((valid) => {
        let ridingExperience = JSON.parse(JSON.stringify(this.state.ridingExp))

        if (this.state.targetExpID !== 'new') {
          ridingExperience[this.state.targetExpID] = values
        }

        if (this.state.targetExpID === 'new') {
          ridingExperience.push(values)
        }

        this.saveExperience(ridingExperience, setSubmitting)
      })
      .catch((errors) => {
        for (let i = 0; i < errors.inner.length; i++) {
          setFieldError(errors.inner[i]['path'], errors.inner[i]['message'])
        }
        setSubmitting(false)
      })
  }

  removeExperience = () => {
    const id = this.state.targetExpID

    if (isNaN(id)) {
      document.body.classList.remove('hide-intercom')
      this.setState({ showExpInputModal: false })
      return
    }

    let ridingExperience = JSON.parse(JSON.stringify(this.state.ridingExp))

    this.setState({
      ridingExpLoading: true,
    })

    ridingExperience[id]._destroy = true

    this.saveExperience(ridingExperience)
  }

  saveExperience = (ridingExperience, setSubmitting = () => {}) => {
    let apiURL = 'users/basic_info'

    let profileData = {
      rider: {
        rider_experiences: [],
      },
    }

    for (let i = 0; i < ridingExperience.length; i++) {
      profileData.rider.rider_experiences.push({
        id: ridingExperience[i].id,
        year: ridingExperience[i].year.toString(),
        make: ridingExperience[i].make,
        model: ridingExperience[i].model,
        years_experience: ridingExperience[i].years_experience,
        currently_own: ridingExperience[i].currently_own,
        category: ridingExperience[i].category
          ? ridingExperience[i].category
          : 'other',
        _destroy: ridingExperience[i]._destroy ? true : false,
      })
    }

    apiProcess(
      apiURL,
      profileData,
      'update-profile',
      'Update Profile from Profile Account Page'
    )
      .then((responseData) => {
        this.setState({
          ridingExp: responseData.user.rider_experiences,
          showExpInputModal: false,
          targetExpID: null,
          showSaveMessage: true,
          ridingExpLoading: false,
        })
        this.props.onChange(responseData.user.rider_experiences)
        setTimeout(() => this.setState({ showSaveMessage: false }), 3500)
        setSubmitting(false)
      })
      .catch((error) => {
        this.setState({
          showSaveError: true,
          ridingExpLoading: false,
        })
        setSubmitting(false)
      })
  }

  defaultValues = () => {
    let id = this.state.targetExpID

    let targetExpValues = {
      make: '',
      model: '',
      year: '',
      years_experience: null,
      currently_own: false,
      category: '',
      id: '',
    }

    if (id !== 'new') {
      targetExpValues = this.state.ridingExp[id]
    }

    return targetExpValues
  }

  isLoading = (isSubmitting) => {
    return isSubmitting || this.state.ridingExpLoading
  }

  findExpLabel = (expValue) => {
    let obj = YEARS_EXPERIENCE_OPTIONS.find((o) => o.value === expValue)

    return obj.text
  }

  render() {
    const { showExpInputModal, ridingExp } = this.state
    const { showEmptyInstructions, motoClassName, align } = this.props
    return (
      <>
        {ridingExp.length > 0 && (
          <React.Fragment>
            {this.state.showSaveMessage && (
              <div className="has-text-success">Riding Experience Updated</div>
            )}
            {ridingExp.map((item, idx) => (
              <>
                {!item._destroy && (
                  <div
                    className={'riding-experience-item-wrap ' + motoClassName}
                  >
                    <Columns className="is-vcentered">
                      <Columns.Column size={8} className="pb-0">
                        <strong className="has-text-grey">
                          {item.year} {item.make} {item.model}
                        </strong>
                        <span className="has-text-grey-light has-text-weight-bold">
                          {' '}
                          - {this.findExpLabel(item.years_experience)}
                        </span>
                      </Columns.Column>
                      <Columns.Column size={4} className="has-text-right pb-0">
                        <Button
                          type="button"
                          outlined
                          size="small"
                          onClick={() => this.openEditModal(idx)}
                        >
                          Edit
                        </Button>
                      </Columns.Column>
                    </Columns>
                  </div>
                )}
              </>
            ))}
          </React.Fragment>
        )}
        {showExpInputModal && (
          <Modal
            show={true}
            closeOnBlur
            closeOnEsc
            size="small"
            key={'exp-form-modal' + this.state.targetExpID}
            onClose={() => {
              document.body.classList.remove('hide-intercom')
              this.setState({ showExpInputModal: false })
            }}
          >
            <>
              <Columns>
                <Columns.Column>
                  <h2 className="is-size-4 header has-text-weight-bold">
                    {this.state.modalTitle}
                  </h2>
                  {this.state.showSaveError && (
                    <div className="has-text-danger">
                      Sorry, please try again.
                    </div>
                  )}
                </Columns.Column>
              </Columns>
              <Formik
                initialValues={this.defaultValues()}
                key={'exp-modal-formik' + this.state.targetExpID}
                onSubmit={(values, { setFieldError, setSubmitting }) =>
                  this.submitExperience(values, setFieldError, setSubmitting)
                }
                render={({
                  errors,
                  setFieldValue,
                  values,
                  handleSubmit,
                  submitForm,
                  setFieldError,
                  setSubmitting,
                  isSubmitting,
                }) => (
                  <form
                    key={'exp-modal-formik-form' + this.state.targetExpID}
                    className=""
                    onSubmit={(e) => {
                      e.stopPropagation()
                      handleSubmit(e)
                    }}
                  >
                    {' '}
                    {this.isLoading(isSubmitting) && (
                      <Loader text="Working..." />
                    )}
                    <MotoLookUp
                      columnSize={4}
                      onYearChange={(value) =>
                        this.updateYear(value, setFieldValue)
                      } //change the temp object
                      onMakeChange={(value) =>
                        this.updateMake(value, setFieldValue)
                      } ///change the temp object
                      onModelChange={
                        //change the temp object
                        (modelInfo) =>
                          this.updateModel(modelInfo, setFieldValue)
                      }
                      errors={errors}
                      values={values}
                      yearID={'year'}
                      makeID={'make'}
                      modelID={'model'}
                    />
                    <Columns>
                      <Columns.Column size={4}>
                        <Field
                          name={'years_experience'}
                          id={'years_experience'}
                          placeholder="Years Experience"
                          label="Years Experience"
                          fullwidth
                          error={errors.years_experience}
                          onChange={({ value }) =>
                            this.updateYearsExperience(value, setFieldValue)
                          }
                          type="select"
                          value={values.years_experience}
                          options={YEARS_EXPERIENCE_OPTIONS}
                        />
                      </Columns.Column>
                      <Columns.Column size={8}>
                        <label className="label">&nbsp;</label>
                        <Field
                          label={'I currently own this motorcycle.'}
                          checked={values.currently_own}
                          type="checkbox"
                          id={this.state.targetExpID + '_checkbox'}
                          name={this.state.targetExpID + '_checkbox'}
                          onChange={({ checked }) =>
                            this.updateCurrentlyOwn(checked, setFieldValue)
                          }
                        />
                      </Columns.Column>
                    </Columns>
                    <Columns
                      style={{
                        marginTop: '2rem',
                        borderTop: '1px solid rgba(0,0,0,.1)',
                        paddingTop: '2rem',
                      }}
                    >
                      <Columns.Column className="has-text-right">
                        <Button
                          type="button"
                          size="small"
                          color="danger"
                          outlined
                          className="mr-3"
                          onClick={() => this.removeExperience()}
                        >
                          Remove
                        </Button>
                        <Button size="small" color="primary" type="submit">
                          Save
                        </Button>
                      </Columns.Column>
                    </Columns>
                  </form>
                )}
              />
            </>
          </Modal>
        )}

        {showEmptyInstructions && ridingExp.length === 0 && (
          <h2 className="title is-size-4">Riding Experience</h2>
        )}
        <div className={`has-text-${align}`}>
          <Button
            type="button"
            outlined={this.props.outlinedButton}
            color="primary"
            onClick={() => this.openEditModal('new')}
            size="medium"
            className="mt-2 custom-primary-button"
            id="input-bike-experience"
          >
            <span className="icon">
              <i className="fas fa-plus"></i>
            </span>
            <span>What bikes have you ridden?</span>
          </Button>
          {this.props.expError && (
            <div className="has-text-danger mt-2">
              Riding experience is required.
            </div>
          )}
        </div>
      </>
    )
  }
}
export default RidingExperienceInput

RidingExperienceInput.defaultProps = {
  ridingExperience: [],
  expError: false,
  onChange: function() {},
  showEmptyInstructions: false,
  outlinedButton: false,
  align: 'left',
}
